import { render, staticRenderFns } from "./AddLocations.vue?vue&type=template&id=ff205370&scoped=true&"
import script from "./AddLocations.vue?vue&type=script&lang=js&"
export * from "./AddLocations.vue?vue&type=script&lang=js&"
import style0 from "./AddLocations.vue?vue&type=style&index=0&id=ff205370&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff205370",
  null
  
)

export default component.exports